<template>
  <!-- <ion-toolbar>
    <ion-title>
      <span>Invitation</span>
    </ion-title>
  </ion-toolbar> -->


  <div class="main_wrapper ion-padding">
    <div class="container">
      <div class="auth-header">
                <div class="auth-heading">
                    <h1>Invitation</h1>
                    <!-- <p class="auth-subtext">An invitation for you.</p> -->
                </div>
                <div class="brand-icon">
                    <SvgIcon name="brandIcon" width="32" height="32" viewBox="0 0 32 32" fill="none"/>
                </div>
            </div>
      <div class="job_info_wrapper job_info_wrapper--custom">
        <div class="job_shifts_wrapper full">
          <div>
            <p>Dear <b>{{ employeeName }}</b>,</p>
            <p class="margin-0">We are pleased to extend an invitation for you to assume the role of Internal Pool
              in the capacity of <b>{{ employeeType }}</b> for the specified groups outlined below:</p>
            <br />
            <div class="content-invitation">
              <div class="header_title" v-if="groups.length > 1">Groups</div>
              <div class="header_title" v-else>Group</div>
              <div class="header_value">
                <ul v-for="(item, index) in groups" :key="index">
                  <li>{{ item }}</li>
                </ul>
              </div>
            </div>
            <br>
            <p>Kindly acknowledge your acceptance to become a part of the aforementioned groups.</p>
            <el-form class="full_page" :model="formsData.userForm" :rules="formsData.userForm.rules"
              :ref="(el) => (formsData.userForm.ref = el)" :label-position="'top'" @submit.prevent="save('userForm')">

              <el-form-item label="Provide Your Preferred Name" prop="preferred_name">
    
    <el-input v-model="formsData.userForm.preferred_name.value" autocomplete="off" placeholder="Preferred Name" :maxlength="20" @input="checkFormValidation('userForm', true)" @keyup="

formsData.userForm.preferred_name.value = $event.target.value

">

        <template #prefix>

<i class="el-icon-user"></i>
</template>

</el-input>
</el-form-item>
              <!-- <div class="form_text"> -->
                <div class="text">
                  Provide Your Address
                </div>
              <!-- </div> -->
              <el-form-item class="no-scroll" prop="address" :required="true">
                <div class="el-input el-input--prefix">
                  <vue-google-autocomplete id="map" classname="el-input__inner"
                    :ref="(el) => (formsData.userForm.address.ref = el)" v-model="formsData.userForm.address.value.text"
                    placeholder="Find your address" @placechanged="setAddressData" @keyup="setAddress" :country="countryArray" >
                  </vue-google-autocomplete>
                  <span class="el-input__prefix"><i class="el-input__icon el-icon-search"></i></span>
                </div>
              </el-form-item>
            </el-form>
          </div>
          <div class="button_submit mb0">
            <div class="btns-group">
              <el-button class="submit_page" type="red" @click="gotToReject()">
                Decline
              </el-button>
              <el-button class="submit_page" type="blue" :disabled="formsData.userForm.disabled"
                @click="gotToAccept('userForm')">
                Accept
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>



</template>

<script>


import {
  ref,
  onMounted,
  inject,
  onBeforeMount,
  computed,
} from "vue";
import { ElMessageBox } from "@/components/Vendor/Element";
import { addIcons } from "ionicons";
import { arrowBackOutline } from "ionicons/icons";
//  import formHooks from "@/hooks/form/form";
addIcons({
  "arrow-back-outline": arrowBackOutline,
});

import { useStore } from "vuex";
import {
  useRouter,
  useRoute
} from "vue-router";

import formHooks from "@/hooks/form/form";
import formValidate from "@/hooks/form/validate/validate";

import addressText from "@/helpers/address/address.js";
import { VueGoogleAutocomplete } from "@/components/components";
export default {
  components: {
    // IonToolbar,
    // IonButton,
    // IonButtons,
    // IonIcon,

    VueGoogleAutocomplete,
  },
  setup() {
    const $store = useStore();
    const $router = useRouter();
    const route = useRoute();

    const setPageClassGlobal = inject("setPageClassGlobal");
    const googleMaps = inject(["googleMaps"]);
    let pharmacyName = ref('');
    let employeeName = ref('');
    let employeeType = ref('');
    let groups = ref('');
    let mainAddress = ref('');
    console.log("🚀 ~ setup213213 ~ mainAddress:", mainAddress.value)
    //  let address = {
    //   text: "",
    // };
    // let addressDisabled = ref(false);
    const close = () => {
      $router.push({
        name: "auth",
      });
    }

    const countryArray = computed(() => {
            const region = process.env.VUE_APP_REGION;
            if (region === 'US') return ['us'];
            if (region === 'AU') return ['au'];
            return []; // Default or empty if region is not recognized
        });


    const gotToReject = () => {
      (async () => {
        try {
          await $store.dispatch("EMPLOYEE_LOCUM_REJECT", { invitationId: route.params.invitationId, });
          let massageText = {
            title: 'You have declined the invitation.'
          };
          await ElMessageBox.confirm(massageText.title, {
            showCancelButton: false,
            confirmButtonText: 'Ok',
            confirmButtonClass: 'el-button--grey',
            showClose: false,
            type: 'success',
            customClass: 'modal_success star',
            callback: () => {
              $router.push({
                name: "home",
              });
            }
          });

        } catch (error) {
          console.log(error);
          console.log("error submit!!");
        }
      })();
    }

    const gotToAccept = (formName) => {


      (async () => {

        formsRefs[formName].value.validate((valid) => {
          if (valid) {
            (async () => {
              try {
                let data = getFormValues(formName);
                await $store.dispatch("EMPLOYEE_LOCUM_ACCEPT", { invitationId: route.params.invitationId, data: data });

                let massageText = {
                  title: 'You have accepted the invitation. We will inform the group manager.'
                };

                await ElMessageBox.confirm(massageText.title, {
                  showCancelButton: false,
                  confirmButtonText: 'Ok',
                  confirmButtonClass: 'el-button--grey',
                  showClose: false,
                  type: 'success',
                  customClass: 'modal_success star',
                  callback: () => {
                    $router.push({
                      name: "auth",
                    });
                  }
                });
              } catch (error) {
                console.log("error submit!!");
              }
            })();
          } else {
            setFormValidation(formName, false, false);
            console.log("error submit!!");
            return false;
          }
        });


      })();
    }



    const setAddress = () => {
      console.log("tttttttttt")
      if (
        formsData.userForm.address.value.text !=
        formsData.userForm.address.value.temp
      ) {
        formsData.userForm.address.value.text = null;
      }
      checkFormValidation("userForm", true);
    };

    const setAddressData = async (addressData, placeResultData) => {
      try {
        formsData.userForm.address.value.lat = addressData.latitude.toString();
        formsData.userForm.address.value.lng = addressData.longitude.toString();
        formsData.userForm.address.value.subpremise = addressData.subpremise
          ? addressData.subpremise
          : "";
        formsData.userForm.address.value.street =
          (formsData.userForm.address.value.subpremise
            ? formsData.userForm.address.value.subpremise + "/"
            : "") +
          (addressData.street_number ? addressData.street_number + " " : "") +
          addressData.route;

        formsData.userForm.address.value.state =
          addressData.administrative_area_level_1
            ? addressData.administrative_area_level_1
            : "";
        formsData.userForm.address.value.suburb = addressData.locality
          ? addressData.locality
          : "";
        formsData.userForm.address.value.country = addressData.country
          ? addressData.country
          : "";
        formsData.userForm.address.value.postcode = addressData.postal_code
          ? addressData.postal_code
          : "";

        console.log("placeResultData", placeResultData.formatted_address);
        formsData.userForm.address.value.text =
          placeResultData.formatted_address;
        formsData.userForm.address.value.temp =
          placeResultData.formatted_address;
        formsData.userForm.address.ref.update(
          formsData.userForm.address.value.text
        );
        const timezone = await googleMaps.getTimeZone(
          formsData.userForm.address.value.lat +
          "," +
          formsData.userForm.address.value.lng
        );
        formsData.userForm.address.value.timezone = timezone.timeZoneId;
      } catch (error) {
        console.log(error);
      }
      checkFormValidation("userForm", true);
    };


    // const onAddressCheckboxChange = () => {
    //   if (formsData.userForm.address.disabled) {
    //     formsData.userForm.address.valueTemp =
    //       formsData.userForm.address.value.text;
    //     formsData.userForm.address.value.text = addressText(mainAddress.address);
    //     formsData.userForm.address.ref.update(addressText(mainAddress.address));
    //     formsData.userForm.address.disabled = true;

    //     formsData.userForm.shop_number.valueTemp =
    //       formsData.userForm.shop_number.value;
    //     formsData.userForm.shop_number.value = mainAddress.address.shopNumber;

    //     formsData.userForm.shop_number.disabled = true;
    //     console.log(true);
    //   } else {
    //     formsData.userForm.address.value.text =
    //       formsData.userForm.address.valueTemp;
    //     formsData.userForm.address.ref.update(
    //       formsData.userForm.address.valueTemp
    //     );
    //     formsData.userForm.shop_number.value =
    //       formsData.userForm.shop_number.valueTemp;
    //     formsData.userForm.shop_number.disabled = false;
    //     formsData.userForm.address.disabled = false;
    //     console.log(false);
    //   }
    //   checkFormValidation("userForm", true, "address");
    // };


    onMounted(() => {
      setPageClassGlobal("global_employee_confirm_page");
      setFormRefs();
      formsData.userForm.address.ref.update(
        formsData.userForm.address.value.text
      );
      checkFormValidation("userForm", false);
    });

    onBeforeMount(async () => {
      (async () => {
        const preferredInfo = await $store.dispatch("GET_EMPLOYEE_LOCUM_INFO", {
          invitationId: route.params.invitationId,
        });
        pharmacyName.value = preferredInfo.groupManagerName;
        employeeName.value = preferredInfo.name;
        employeeType.value = preferredInfo.internalEmployeeType;
        groups.value = preferredInfo.groups;
        mainAddress.value = preferredInfo.address;
        console.log("🚀 ~ mainAddress:", mainAddress.value)
        formsData.userForm.address.value.text = addressText(mainAddress.value ? mainAddress.value : "");
        formsData.userForm.address.value.temp = addressText(mainAddress.value ? mainAddress.value : "");
        formsData.userForm.address.ref.update(
          formsData.userForm.address.value.text
        );
        checkFormValidation("userForm", false);
      })();
    });


    const formsDataArray = {
      userForm: {
        address: {
          value: {
            text: "",
            temp: "",
          },
          resetValue: true,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "address",
                  callback,
                  setFormValidation
                );
              },
            },
          ],
        },
        preferred_name: {
            value: "",
        },
      },
    };

    const {
      checkFormValidation,
      setFormValidation,
      formsData,
      setFormRefs,
      getFormValues,
      formsRefs,
    } = formHooks(formsDataArray);

    return {

      gotToAccept,
      gotToReject,
      pharmacyName,
      employeeName,
      employeeType,
      groups,
      close,
      formsData,
      setAddressData,
      setAddress,
      mainAddress,
      countryArray
    };
  },
};
</script>

<style scoped>
table {
  width: 100%;
  border-collapse: collapse;
}

th,
td {
  border: 1px solid #000;
  /* Add the desired border style and color here */
  padding: 8px;
  text-align: center;
  font-weight: bold
}

th {
  background-color: #f2f2f2;
  /* Add background color for headers if needed */
}
</style>